import { render, staticRenderFns } from "./Tab1.vue?vue&type=template&id=20b8fc14&scoped=true"
import script from "./Tab1.vue?vue&type=script&lang=js"
export * from "./Tab1.vue?vue&type=script&lang=js"
import style0 from "./Tab1.vue?vue&type=style&index=0&id=20b8fc14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8fc14",
  null
  
)

export default component.exports